<mat-card appearance="outlined" class="mat-elevation-z4">
    <mat-card-header>
        <mat-card-title>{{ amount | slNumber: decimalPlaces }}{{ symbol }}</mat-card-title>
        <mat-card-subtitle class="count-display-subtitle">{{ label }}</mat-card-subtitle>
    </mat-card-header>
</mat-card>
